import { render, staticRenderFns } from "./MainTop.vue?vue&type=template&id=6d31a5f0&scoped=true&"
import script from "./MainTop.vue?vue&type=script&lang=js&"
export * from "./MainTop.vue?vue&type=script&lang=js&"
import style0 from "./MainTop.vue?vue&type=style&index=0&id=6d31a5f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31a5f0",
  null
  
)

export default component.exports